import { useEffect, useRef } from 'react'

import { Button, InputRef } from 'antd'
import { createStyles } from 'antd-style'

import { nextTick } from '@eastcoal/common/utils/nextTick'
import { pick } from '@eastcoal/common/utils/object'

import { FormItem } from '@eastcoal/formily/components/FormItem'
import { Input } from '@eastcoal/formily/components/Input'
import { onInputMount } from '@eastcoal/formily/components/Input/effects/onInputMount'
import { SchemaForm } from '@eastcoal/formily/components/SchemaForm'
import { SchemaItem } from '@eastcoal/formily/components/SchemaForm/interface'
import { onFormValuesChange } from '@eastcoal/formily/exports/core'
import { useCreationForm } from '@eastcoal/formily/hooks/useCreationForm'

import { FloatPopover } from '../../FloatPopover'
import { useLinkCardStore } from '../Store/hooks/useStore'

const useStyles = createStyles(({ token }) => ({
  form: {
    width: 400,
    padding: token.padding
  }
}))

const schema: SchemaItem[] = [
  {
    name: 'text',
    title: '文本',
    type: 'string',
    'x-component': Input,
    'x-component-props': {
      autoFocus: true
    },
    'x-decorator': FormItem,
    'x-decorator-props': {
      colon: false,
      layout: 'vertical'
    }
  },
  {
    name: 'url',
    title: '链接',
    type: 'string',
    'x-component': Input,
    'x-decorator': FormItem,
    'x-decorator-props': {
      colon: false,
      layout: 'vertical'
    }
  }
]

export const LinkForm = () => {
  const {
    nodeKey,
    text,
    url,
    formVisible,
    syncFormData,
    updateLinkNode,
    toggleFormVisible
  } = useLinkCardStore(state =>
    pick(state, [
      'nodeKey',
      'text',
      'url',
      'syncFormData',
      'updateLinkNode',
      'formVisible',
      'toggleFormVisible'
    ])
  )

  const urlRef = useRef<InputRef>(null)

  const form = useCreationForm({
    values: {
      text,
      url
    },
    effects() {
      onFormValuesChange(() => {
        syncFormData(form.values)
      })
      onInputMount('url', ({ ref }) => {
        urlRef.current = ref.current
      })
    }
  })

  const hanldeConfirm = () => {
    updateLinkNode()
    toggleFormVisible()
  }

  useEffect(() => {
    if (formVisible) {
      nextTick(() => {
        urlRef.current?.focus()
      })
    }
  }, [formVisible])

  const { styles } = useStyles()

  return (
    <FloatPopover
      nodeKey={nodeKey}
      open={formVisible}
      placement='bottomLeft'
      // 使用一个不可能被触发的事件让状态完全由外部控制
      trigger='contextMenu'
      onOpenChange={toggleFormVisible}
    >
      <SchemaForm
        className={styles.form}
        form={form}
        grid={false}
        name='editorLinkForm'
        schema={schema}
      >
        <Button disabled={!url} type='default' onClick={hanldeConfirm}>
          确定
        </Button>
      </SchemaForm>
    </FloatPopover>
  )
}
